import React from "react";
import { euro } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { Copy } from "lucide-react";

const STATI = [["completata", "Attivazione completata"], ["errore", "Errore"], ["annullata", "Annullamento"], ["in_lavorazione", "In lavorazione"]];
const BILLING = [["prepagato", "Credito prepagato"], ["consumo", "A consumo, fattura a fine mese"]];
const asText = (v) => (Array.isArray(v) ? v.join(", ") : v || "");
export const toList = (v) => (Array.isArray(v) ? v : String(v || "").split(",")).map((x) => x.trim()).filter(Boolean);

const CopyRow = ({ label, value, testid }) => (
  <button type="button" className="w-full grid grid-cols-[3.5rem_1fr_auto] items-center gap-2 text-left text-xs hover:text-primary" onClick={() => { navigator.clipboard?.writeText(value || ""); toast.success(`${label} copiato`); }} data-testid={testid}>
    <span className="text-muted-foreground">{label}</span><span className="font-mono break-all">{value || "—"}</span><Copy className="w-3.5 h-3.5" />
  </button>
);

export const OperatorApiCard = ({ op, value, onChange }) => {
  const set = (k, v) => onChange({ ...value, [k]: v });
  return (
    <Card className="p-5 space-y-4" data-testid="op-api">
      <div><h2 className="font-head text-lg font-semibold">Credito e collegamento con l'operatore</h2><p className="text-xs text-muted-foreground">L'operatore invia a questo indirizzo gli aggiornamenti delle pratiche e del tuo credito presso di lui.</p></div>
      <div className="grid md:grid-cols-2 gap-4">
        <div className="space-y-2"><Label>Come ti fattura l'operatore</Label>
          <div className="flex flex-wrap gap-2">{BILLING.map(([k, l]) => <Button key={k} type="button" size="sm" variant={value.billing_mode === k ? "default" : "outline"} onClick={() => set("billing_mode", k)} data-testid={`op-billing-${k}`}>{l}</Button>)}</div>
        </div>
        <div><Label>Correggi il credito a mano (€)</Label>
          <Input type="number" step="0.01" className="mt-1.5" value={value.credit_new} onChange={(e) => set("credit_new", e.target.value)} placeholder={op.credit_balance == null ? "Nessun saldo ricevuto" : `Attuale ${euro(op.credit_balance)}`} data-testid="op-credit-input" />
          <p className="text-xs text-muted-foreground mt-1">Di norma lo aggiorna l'operatore: lascia vuoto per non cambiarlo.</p>
        </div>
      </div>
      <div className="rounded-lg border border-primary/30 bg-primary/5 p-3 space-y-1.5" data-testid="op-webhook-box">
        <CopyRow label="URL" value={op.webhook_url} testid="op-webhook-url" />
        <CopyRow label="Token" value={op.webhook_secret} testid="op-webhook-secret" />
        <p className="text-xs text-muted-foreground">Il token va inviato nell'intestazione <span className="font-mono">X-Webhook-Secret</span> (oppure <span className="font-mono">?token=</span>). Il credito viene letto dai campi credit, credito, balance o saldo.</p>
      </div>
      <label className="flex items-center gap-2 text-sm"><Switch checked={value.auto_status} onCheckedChange={(v) => set("auto_status", v)} data-testid="op-auto-status" />Aggiorna le pratiche in automatico con gli stati inviati dall'operatore</label>
      {value.auto_status && <div className="grid sm:grid-cols-2 gap-3">{STATI.map(([k, l]) => (
        <div key={k}><Label className="text-xs">{l}: parole usate dall'operatore, separate da virgola</Label>
          <Input className="mt-1 font-mono text-xs" value={asText(value.status_map[k])} onChange={(e) => set("status_map", { ...value.status_map, [k]: e.target.value })} data-testid={`op-status-map-${k}`} /></div>
      ))}</div>}
    </Card>
  );
};
